module.exports = __webpack_public_path__ + "static/media/5.f53488f5.jpg";